import { objectValueOrDefault, configQuery, ipCountryQuery, ValidationGuard, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Watch, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { verifyPhoneCoreX } from '../../../sdk/sign-up-sdk.js';
import { IS_ACCOUNT_VERIFIED, SignupErrorTranslationKeys } from '../sign-up.constants.js';
import { store } from '../../../store/index.js';
import Component from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { exactLength } from '@gig/magic-form-builder';
import { notificationService, NotificationDelay } from '@gig/magic-messaging';

var DEFAULT_SMS_CODE_LENGTH = 4;
/**
 * Displays sms verification for sign up contains fields to enter the received code
 * and resend link. After providing valid verification code the user will be
 * navigated to keycloak login page
 */
var SmsVerificationComponent = /** @class */ (function (_super) {
    __extends(SmsVerificationComponent, _super);
    function SmsVerificationComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.invalidCode = false;
        _this.isLoading = false;
        _this.code = '';
        /**
         * Length of sms verification code
         */
        _this.smsCodeLengthConfig = DEFAULT_SMS_CODE_LENGTH;
        /**
         * Whether the resend button is disabled
         */
        _this.isResendDisabled = true;
        /**
         * Remaining time in seconds before resend button is enabled
         */
        _this.resendCooldownSeconds = 60;
        /**
         * Timer interval ID
         */
        _this.resendTimer = null;
        return _this;
    }
    Object.defineProperty(SmsVerificationComponent.prototype, "smsCodeLength", {
        get: function () {
            return this.smsCodeLengthConfig;
        },
        enumerable: false,
        configurable: true
    });
    SmsVerificationComponent.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentIpCountry, codeLengthConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ipCountryQuery()];
                    case 1:
                        currentIpCountry = _a.sent();
                        return [4 /*yield*/, configQuery('signup.smsCodeLength')];
                    case 2:
                        codeLengthConfig = _a.sent();
                        this.smsCodeLengthConfig = objectValueOrDefault(codeLengthConfig, currentIpCountry);
                        if (this.initialCode) {
                            this.code = this.initialCode;
                        }
                        this.startResendTimer();
                        return [2 /*return*/];
                }
            });
        });
    };
    SmsVerificationComponent.prototype.onSubmit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoading = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, verifyPhoneCoreX(this.authModel.userID, this.code)];
                    case 2:
                        result = _a.sent();
                        if (!result || !result.verified) {
                            this.handleSignUpError();
                            return [2 /*return*/];
                        }
                        this.finishValidation();
                        localStorage.setItem(IS_ACCOUNT_VERIFIED, '1');
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this.handleSignUpError();
                        return [3 /*break*/, 5];
                    case 4:
                        this.isLoading = false;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SmsVerificationComponent.prototype.handleSignUpError = function () {
        this.code = '';
        this.invalidCode = true;
        notificationService.error(this.$t(SignupErrorTranslationKeys.INVALID_VERIFICATION_CODE), { closeDelay: NotificationDelay.PERMANENT });
    };
    SmsVerificationComponent.prototype.verificationError = function (code) {
        return code;
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    SmsVerificationComponent.prototype.finishValidation = function () { };
    SmsVerificationComponent.prototype.resetError = function (code) {
        if (!code) {
            return;
        }
        this.invalidCode = false;
    };
    SmsVerificationComponent.prototype.preventNonDigits = function (event) {
        if (event.inputType === 'insertFromPaste') {
            return;
        }
        if (event.data && !/^\d$/.test(event.data)) {
            event.preventDefault();
        }
    };
    /**
     * Starts the resend cooldown timer
     */
    SmsVerificationComponent.prototype.startResendTimer = function () {
        var _this = this;
        this.isResendDisabled = true;
        this.resendCooldownSeconds = 60;
        if (this.resendTimer) {
            clearInterval(this.resendTimer);
        }
        this.resendTimer = window.setInterval(function () {
            if (_this.resendCooldownSeconds > 0) {
                _this.resendCooldownSeconds--;
            }
            else {
                _this.isResendDisabled = false;
                if (_this.resendTimer) {
                    clearInterval(_this.resendTimer);
                    _this.resendTimer = null;
                }
            }
        }, 1000);
    };
    /**
     * Resends the verification code
     */
    SmsVerificationComponent.prototype.resendCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isResendDisabled) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, magic.methods.users.resendUserVerification(this.authModel.userID, 'phone')];
                    case 2:
                        _a.sent();
                        this.startResendTimer();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.verificationError('RESEND_FAILED');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    SmsVerificationComponent.prototype.beforeDestroy = function () {
        if (this.resendTimer) {
            clearInterval(this.resendTimer);
            this.resendTimer = null;
        }
    };
    __decorate([
        Prop(Object),
        __metadata("design:type", Object)
    ], SmsVerificationComponent.prototype, "authModel", void 0);
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], SmsVerificationComponent.prototype, "initialCode", void 0);
    __decorate([
        ValidationGuard(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SmsVerificationComponent.prototype, "onSubmit", null);
    __decorate([
        Emit('verification-error'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SmsVerificationComponent.prototype, "verificationError", null);
    __decorate([
        Emit('verified'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SmsVerificationComponent.prototype, "finishValidation", null);
    __decorate([
        Watch('code'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], SmsVerificationComponent.prototype, "resetError", null);
    SmsVerificationComponent = __decorate([
        Component({
            name: 'corex-sms-verification',
            store: store,
            validations: function () {
                return {
                    code: {
                        exactLength: exactLength(this.smsCodeLengthConfig),
                        required: required,
                    },
                };
            },
        })
    ], SmsVerificationComponent);
    return SmsVerificationComponent;
}(Mixins(validationMixin, MagicConfigMixin)));

export default SmsVerificationComponent;
